/**
 * nexus 展示环境的演示身份解析（与 web-v2 的 utils/nexus.ts 保持同一优先级）。
 *
 * 优先 URL 参数 ?nexus_union_id=（换演示人时无需重新构建），其次构建期配置
 * VITE_NEXUS_UNION_ID。该 unionId 由 web-v2 按 source='nexus' 免扫码登录，
 * 必须命中后端 NEXUS_DEMO_UNION_IDS 白名单；未配置时无法建立 nexus 会话，
 * web-v2 将落到登录页（可扫码登录）。
 * */
export function resolveNexusUnionId(): string {
  const fromQuery = new URLSearchParams(window.location.search).get(
    'nexus_union_id',
  );
  return (fromQuery || import.meta.env.VITE_NEXUS_UNION_ID || '').trim();
}
